import { Tooltip } from "@mui/material";
import React from "react";
import { StyledEditFormHeaders } from "../../../styled/form";

const EditFormHeader = ({
  handleClose,
  commonProperties,
  idSiniestro,
  artName,
}) => {
  return (
    <StyledEditFormHeaders.Container>
      <StyledEditFormHeaders.TitleContainer>
        <StyledEditFormHeaders.NameText>
          {
            (
              (!!commonProperties.nombreTrabajador
                ? commonProperties.nombreTrabajador + ' ' + commonProperties.apellidoTrabajador
                : (!!commonProperties.trabajador
                  ? commonProperties.trabajador
                  : ""
                )
              )
            )

            + ` ${commonProperties.documento}`
          }
        </StyledEditFormHeaders.NameText>
        <StyledEditFormHeaders.Text>{artName}</StyledEditFormHeaders.Text>
        <StyledEditFormHeaders.Text>
          Siniestro {commonProperties.numeroHistoriaClinica}
        </StyledEditFormHeaders.Text>
      </StyledEditFormHeaders.TitleContainer>
      <Tooltip title="Cerrar">
        <StyledEditFormHeaders.CloseIcon onClick={handleClose} />
      </Tooltip>
    </StyledEditFormHeaders.Container>
  );
};

export default EditFormHeader;
